import http, { HTTPException } from '@/http'

export default {
  state: () => ({}),

  getters: {},

  mutations: {},

  actions: {
    async update(context, credentials) {
      let { new_pass } = await http.post('profile/reset/pass', credentials)

      if (!new_pass) {
        throw new HTTPException('Ошибка обновления пароля')
      }

      return new_pass
    }
  },

  namespaced: true
}
